// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"86":"b32482e3","244":"f64cbd68","784":"6de4353d","799":"0bcdd6ff","995":"b1c8b0eb"}[chunkId] + ".css";
};